import React, { useEffect, useState } from 'react';
import { assetsService } from '../../services/assetsService';
import { YButton } from '../../ui/YButton';
import { YCard } from '../../ui/YCard';

export function AssetPickerModal({ show, onHide, onSelect }) {
  const [scope, setScope] = useState('all');
  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!show) return;
    (async () => {
      try {
        setLoading(true);
        setError('');
        const list = await assetsService.listMine(scope);
        setAssets(list);
      } catch (e) {
        setError('Failed to load photos');
        setAssets([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [show, scope]);

  // Close on Escape
  useEffect(() => {
    if (!show) return;
    const handler = (e) => {
      if (e.key === 'Escape') {
        if (onHide) onHide();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [show, onHide]);

  if (!show) return null;
  return (
    <>
      <div
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1050 }}
        onClick={onHide}
        aria-hidden="true"
      />
      <div
        style={{ position: 'fixed', top: '10%', left: '50%', transform: 'translateX(-50%)', zIndex: 1051, width: 'min(920px, 96vw)' }}
        role="dialog"
        aria-modal="true"
        aria-label="Choose from My Photos"
      >
        <YCard title="Choose from My Photos" headerVariant="muted">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 flex-wrap">
              {['all','harvest','profile','board','message'].map((s) => (
                <YButton
                  key={s}
                  variant={scope === s ? 'primary' : 'secondary'}
                  size="sm"
                  onClick={() => setScope(s)}
                >
                  {s === 'all' ? 'All' : s.charAt(0).toUpperCase() + s.slice(1)}
                </YButton>
              ))}
            </div>
            <YButton variant="secondary" onClick={onHide}>Close</YButton>
          </div>
          {error && <div className="text-danger small mb-2">{error}</div>}
          {loading ? (
            <div className="text-muted">Loading…</div>
          ) : assets.length === 0 ? (
            <div className="text-muted">No photos found.</div>
          ) : (
            <div className="row g-3">
              {assets.map((a) => (
                <div key={a.id} className="col-6 col-md-4 col-lg-3">
                  <div className="position-relative">
                    <img
                      alt=""
                      src={a.thumb_url || a.url}
                      loading="lazy"
                      decoding="async"
                      style={{ width: '100%', borderRadius: 8, objectFit: 'cover', aspectRatio: '4 / 3', cursor: 'pointer' }}
                      onClick={() => onSelect && onSelect(a)}
                    />
                    <div className="small text-muted mt-1 text-truncate">
                      {a.scope}
                    </div>
                    <YButton variant="secondary" size="sm" className="mt-1 w-100" onClick={() => onSelect && onSelect(a)}>
                      Use this photo
                    </YButton>
                  </div>
                </div>
              ))}
            </div>
          )}
        </YCard>
      </div>
    </>
  );
}


